import Modal from "react-bootstrap/Modal";
import { Button } from "../../common/Button";
import { useState } from "react";
import { createServiceLine } from "../../api/ServiceLine";
import { failed, success } from "../../common/Toastify";
import { Col, Row, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import TextInput from "../../common/textfield/TextInput";
import TextArea from "../../common/textfield/TextArea";

const CreateServiceLineModal = ({ orgData, onShow, onHide }) => {
  const [isLoading, setIsLoading] = useState(false);
  // Validation schema for formik
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .max(64, "Maximum 64 characters allowed")
      .required("Display Name is required"),
    description: Yup.string()
      .max(128, "Maximum 256 characters allowed")
      .required("Description is required"),
  });

  return (
    <Modal
      backdropClassName
      backdrop={"static"}
      show={onShow}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{ textTransform: "capitalize" }}
        >
          {"Create Service Line"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={{
              name: "",
              description: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              setIsLoading(true);

              let payload = {
                active: true,
                name: values?.name,
                description: values?.description,
                orgId: orgData?.id,
              };

              createServiceLine(orgData?.id, payload)
                .then((res) => {
                  if (res?.status === true) {
                    success(res?.message);
                    onHide();
                  }
                })
                .catch((res) => {
                  failed(res?.message);
                })
                .finally(() => setIsLoading(false));
            }}
          >
            {(formik) => {
              return (
                <form
                  className="common-form border-fields"
                  onSubmit={formik.handleSubmit}
                >
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <TextInput
                          type={"text"}
                          keyField={"name"}
                          label={"Name"}
                          formik={formik}
                          placeholder={"Name"}
                          required={true}
                        />

                        {formik.touched.display && formik.errors.display && (
                          <div className="invalid-feedback">
                            {formik.errors.display}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <TextArea
                          type={"text"}
                          keyField={"description"}
                          label={"Description"}
                          formik={formik}
                          placeholder={"Description"}
                          required={true}
                        />
                        {formik.touched.description &&
                          formik.errors.description && (
                            <div className="invalid-feedback">
                              {formik.errors.description}
                            </div>
                          )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Submit Buttons */}
                  <div
                    className="btn-wrap"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "2rem",
                      gap: "1rem",
                    }}
                  >
                    <Button
                      variant="secondary"
                      title="Cancel"
                      onClick={() => onHide()}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" isLoading={isLoading}>
                      Create
                    </Button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateServiceLineModal;
